module.exports = __webpack_public_path__ + "img/HomePage.93e192d8.png";